import { Box, Checkbox, Typography } from '@mui/material';
import { type IBooleanAttribute } from '../../../Interfaces/ILegalTransactionMeasure';

export const BooleanAttribute = ({
  attribute,
  onUpdateAttribute,
}: {
  attribute: IBooleanAttribute;
  onUpdateAttribute: (attribute: IBooleanAttribute) => void;
}) => {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', minWidth: '300px' }}>
      <Checkbox
        size='small'
        checked={attribute.Value ?? false}
        required={attribute.Required}
        onChange={e =>
          onUpdateAttribute({ ...attribute, Value: e.target.checked })
        }
      />
      <Typography>{attribute.Name}</Typography>
    </Box>
  );
};
